<template>
  <div class="s-playing-now__options__list-view">
    <div
      class="e-view-options e-view-options__horizontal"
      :class="horizontalActiveView"
      @click="changeView('horizontal')"></div>
    <div
      class="e-view-options e-view-options__grid"
      :class="gridActiveView"
      @click="changeView('grid')"></div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const emit = defineEmits(['change-view'])
const currentView = ref('horizontal')

const horizontalActiveView = computed(() => {
  return currentView.value === 'horizontal' ? 'e-view-options--active' : ''
})
const gridActiveView = computed(() => {
  return currentView.value === 'grid' ? 'e-view-options--active' : ''
})

const changeView = (viewType) => {
  currentView.value = viewType
  emit('change-view', viewType)
}
</script>
